import { supabase } from './supabaseClient'

export async function toggleGrocerySecured(itemId: string, secured: boolean): Promise<{ error: string | null }> {
  const { error } = await supabase.from('grocery_manifest').update({ is_secured: secured }).eq('id', itemId)
  return { error: error?.message ?? null }
}
